import { AveragePlayerScore } from '#src/__generated__/globalTypes.ts';

import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useDefaultAverageScore = () => {
  const {
    flags: { useLastTenPlayedAverageAsDefault = false },
  } = useFeatureFlags();

  return useLastTenPlayedAverageAsDefault
    ? AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
    : AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE;
};
